<div class="header">
    <div class="logo"><img src="/assets/img/mobile-logo.svg" alt=""></div>
    <div class="menu-icon"></div>

</div>

<div class="menu"></div>